module.exports = __webpack_public_path__ + "img/shigongzhong.93a9a296.png";